"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTaskListSummaryBanner = void 0;
const react_i18next_1 = require("react-i18next");
function useTaskListSummaryBanner({ requireAttentionItemsCount }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    let bannerText;
    if (requireAttentionItemsCount === 1) {
        bannerText = t('time_and_attendance_TaskList_RequireAttentionCount_One');
    }
    else {
        bannerText = t('time_and_attendance_TaskList_RequireAttentionCount_Other', {
            count: requireAttentionItemsCount
        });
    }
    return {
        bannerText,
        bannerIconAltText: t('time_and_attendance_TaskList_RequireAttention'),
        bannerLinkText: t('time_and_attendance_TaskList_ViewTasks'),
        bannerLinkA11yHint: t('time_and_attendance_TaskList_ViewTasksAccessibilityHint')
    };
}
exports.useTaskListSummaryBanner = useTaskListSummaryBanner;
